export default __webpack_public_path__ + "static/media/hidroponia.761eaade.png";